
import { Vue } from "vue-class-component";

export default class ImageUpload extends Vue {}
